import { createFileRoute } from '@tanstack/react-router'
import { TravelersPanel } from '@/components/me/travelers-panel'

export const Route = createFileRoute('/travelers')({
  component: TravelersPanel,
})
